/** Projeção visual dos fatos oficiais; não substitui as ações nem as validações do portal. */
import { providerJourneyAction } from './providerPortalRules';

export interface ServiceOrderJourney {
  travel_started_at: string | null;
  checked_in_at: string | null;
  checklists_total: number;
  checklists_completed: number;
  checklist_stage?: string | null;
}

/** Estados finais/pausa prevalecem sobre marcos incompletos de OS antigas. */
export function serviceOrderJourneyLabel(status: string, paused: boolean, journey?: ServiceOrderJourney | null): string {
  if (status === 'open') return 'Sem agendamento';
  // Logística: etapas antes do agendamento
  if (status === 'awaiting_shipment') return 'Aguardando postagem';
  if (status === 'shipment_in_transit') return 'Equipamento em trânsito';
  if (status === 'shipment_delivered') return 'Equipamento entregue';
  if (status === 'to_reschedule') return 'Reagendar';
  if (status === 'cancelled') return 'Cancelada';
  if (status === 'completed') return 'Concluída';
  if (status === 'in_correction') return paused ? 'Correção pausada' : 'Em correção';
  if (!journey && status !== 'awaiting_review') return 'Etapa não registrada';
  const action = providerJourneyAction({ status, isPaused: paused, travelStartedAt: journey?.travel_started_at, checkedInAt: journey?.checked_in_at });
  if (action === 'review') return 'Em revisão';
  if (action === 'resume') return 'Serviço pausado';
  if (action === 'travel_start') return 'Agendada';
  if (action === 'check_in') return 'A caminho';
  if (action === 'start') return 'No local';
  const stages: Record<string, string> = { start: 'Checklist de início', execution: 'Checklist de execução', completion: 'Checklist de conclusão' };
  return journey?.checklist_stage ? stages[journey.checklist_stage] ?? 'Em execução' : 'Em execução';
}